var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { gsap, Power2 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import HeroText from './HeroText';
import TwoColumnsImageText from './TwoColumnsImageText';
import LottieFileSource from '../../assets/Lottie/LongHero.json';
import dispersedTiles from '../../assets/images/LongHeroVideo/DispersedTiles.svg';
import { useObserver as createObserver } from '../../utils/IntersectionObserver/index';
import { useWindowSize } from '../../hooks/useWindowSize';
import './main.scss';
import useReactDomsReady from '../../hooks/useReactDomReady';
gsap.registerPlugin(ScrollTrigger);
var LongHeroVideoComponent = function (props) {
    var width = useWindowSize()[0];
    var ready = useReactDomsReady().ready;
    var _a = props.data, headlineText = _a.headlineText, bodyText = _a.bodyText, eyebrowText = _a.eyebrowText, headSubText = _a.headSubText;
    var scrollerRef = useRef(null);
    var _b = useState({}), observerState = _b[0], setObserverState = _b[1];
    var _c = useState({}), finalPercentageState = _c[0], setFinalPercentageState = _c[1];
    var _d = useState('unstarted'), desktopPositionAnimationFinished = _d[0], setDestkopPositionAnimationFinished = _d[1];
    useEffect(function () {
        createObserver({
            refElement: scrollerRef.current,
            customOptions: {},
            intersectorState: observerState,
            setIntersectorFunction: setObserverState,
            maxRatio: 0,
            minRatio: 1,
        });
    }, []);
    useEffect(function () {
        var _a, _b, _c;
        if (ready) {
            var animationContainerRect = (_a = document
                .getElementById('long-hero-video-scroll-container')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            var heroContainerRect = (_b = document
                .getElementById('hero-text-long-hero-video')) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
            var scrollAnimationRect = (_c = document
                .getElementById('long-hero-video-scroll-animation')) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
            var fullPercentageHeight = animationContainerRect === null || animationContainerRect === void 0 ? void 0 : animationContainerRect.height;
            var position = (scrollAnimationRect === null || scrollAnimationRect === void 0 ? void 0 : scrollAnimationRect.height) - (scrollAnimationRect === null || scrollAnimationRect === void 0 ? void 0 : scrollAnimationRect.bottom) / 2;
            if (position && position < 100) {
                var middlePositionAnimation = position < 0 ? position : position * -1;
                var percentageForFinal = middlePositionAnimation / fullPercentageHeight;
                setFinalPercentageState(percentageForFinal * 100 + "%");
            }
            var middleAnimationContainer = animationContainerRect === null || animationContainerRect === void 0 ? void 0 : animationContainerRect.bottom;
            var vhc = fullPercentageHeight / 1000;
            var bottomHero = heroContainerRect === null || heroContainerRect === void 0 ? void 0 : heroContainerRect.bottom;
            var distanceBetweenMiddleAndBottom = middleAnimationContainer -
                bottomHero -
                (scrollAnimationRect === null || scrollAnimationRect === void 0 ? void 0 : scrollAnimationRect.height) * 0.5;
            var initialPercentage = distanceBetweenMiddleAndBottom / fullPercentageHeight;
            gsap.set("#long-hero-video-scroll-animation", {
                bottom: initialPercentage * 100 + "%",
                ease: 'none',
            });
        }
    }, [width, ready]);
    useEffect(function () {
        var _a;
        if (ready) {
            var customScrollTriggerEvent = new CustomEvent("scrollTriggerLongHeroEnter", {
                detail: {
                    ready: true,
                },
            });
            (_a = document === null || document === void 0 ? void 0 : document.getElementById('long-hero-video-scroll-animation')) === null || _a === void 0 ? void 0 : _a.dispatchEvent(customScrollTriggerEvent);
            var tl = gsap.timeline({
                id: "lottie-animation-scroll-timeline",
                scrollTrigger: {
                    id: "lottie-animation-scroll-trigger",
                    trigger: "#hero-text-long-hero-video",
                    start: '70% center',
                    endTrigger: '#two-columns-image-component',
                    end: '50% center',
                    toggleActions: 'play complete none none',
                    scrub: 1,
                },
            });
            tl.to("#long-hero-video-scroll-animation", {
                bottom: finalPercentageState,
                ease: Power2.easeInOut,
                onStart: function () {
                    setDestkopPositionAnimationFinished('started');
                },
                onComplete: function () {
                    setDestkopPositionAnimationFinished('finished');
                },
                duration: 5,
            });
        }
    }, [observerState, width, ready]);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "relative w-full overflow-x-hidden long-hero-video overflow-y-hidden test", id: "scroll-lock-long-video", ref: scrollerRef }, { children: [_jsx(HeroText, { desktopPositionAnimationFinished: desktopPositionAnimationFinished, mobileImage: dispersedTiles, headlineText: headlineText, bodyText: bodyText }, void 0),
                _jsx(TwoColumnsImageText, { desktopPositionAnimationFinished: desktopPositionAnimationFinished, eyebrowText: eyebrowText, lottieFile: LottieFileSource, headSubText: headSubText }, void 0)] }), void 0) }, void 0));
};
export default LongHeroVideoComponent;
